export default __webpack_public_path__ + "static/media/iCal.793a3222.png";